import {
  mapState,
  mapMutations
} from 'vuex'
import QrcodeVue from 'qrcode.vue'
import api from '../../service/services'
import swal from 'sweetalert2'
export default {
  props: ['time', 'saleTypeText'],
  components: {
    QrcodeVue
  },
  data() {
    return {
      qrcode: '',
      pp: {
        sku_id: 4,
        image_name: 'promptpay',
        color: 'badge-info',
        goto: 'QRpay',
        image_path: require('../../assets/promptpay.png'),
        title_name: [
          {
            name_id: 0,
            name: 'Prompt Pay',
            say: 'Payment By Prompt Pay'
          },
          {
            name_id: 1,
            name: 'พรอมเพย์',
            say: 'ชำระเงินผ่านระบบพรอมเพย์'
          },
          {
            name_id: 2,
            name: '及时付款',
            say: '通過即時支付付款'
          }
        ]
      }
    }
  },
  computed: {
    ...mapState(['isLoading','SaleID']),
  },
  methods: {
    checkTime() {
      this.$store.state.loopPP = setInterval(() => {
        this.checkPromptpay()
        if (this.time == 0) {
          if(this.$store.state.AmountPayment >= this.$store.state.total){
            console.log("มีเงินอยู่")
          } else {
          clearInterval(this.$store.state.loopPP)
          }
        }
      }, 1000)
    },
    genqrcode() {
      this.$store.state.isLoading = true
      console.log(this.$store.state.accessToken)
      const header = {
        headers: {
          'x-access-token': this.$store.state.accessToken
        }
      }
      console.log('UUID ', this.$store.state.UUID)
      console.log('txn_id ', this.$store.state.txn_id)
      if (this.$store.state.SaleID == 1) {
        var payload = {
          vending_uuid: this.$store.state.UUID,
          order_uuid: this.$store.state.txn_id,
          amount: 0,
          client_name: this.$store.state.config.client.branch,
          terminal_id: this.$store.state.config.vending.terminal_id
        }
      } else {
        var payload = {
          vending_uuid: this.$store.state.UUID,
          order_uuid: this.$store.state.txn_id,
          // amount: 0.01,
          amount: parseFloat(this.$store.state.total),
          client_name: this.$store.state.config.client.branch,
          terminal_id: this.$store.state.config.vending.terminal_id
        }
      }
      console.log(payload)
      api.callqrcode(
        payload,
        header,
        result => {
          console.info(result)
          if (result.response === 'success') {
            this.qrcode = result.data.qr_tag
            console.log(this.qrcode)
            this.checkTime()
          } else {
            this.$store.state.isLoading = true
            this.$store.state.isLoading = false
            swal
              .fire({
                title: 'Gen QRCode ERROR',
                text: 'สถานะการตอบกลับ ' + result.status,
                type: 'error',
                animation: true,
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'OK !'
              })
          }
        },
        error => {
          alert(JSON.stringify(error))
        }
      )
    },
    checkPromptpay() {
      const header = {
        headers: {
          'x-access-token': this.$store.state.accessToken
        }
      }
      var payload = {
        vending_uuid: this.$store.state.UUID,
        order_uuid: this.$store.state.txn_id,
        amount: parseFloat(this.$store.state.total),
        client_name: this.$store.state.config.client.branch,
        terminal_id: this.$store.state.config.vending.terminal_id,
        qr_tag: this.qrcode
        // qr_tag: "sadasdasdsadasdasd"
      }
      // console.log(payload)
      api.checkPaymentWallet(
        payload,
        header,
        result => {
          // console.log('checkPromptpay = ', result)
          if (result.response === 'success') {
            if (result.data.status == 'completed' && result.data.method == "promptpay") {
            // if (result.data.status == 'completed') {
              console.log('completed = ', result)
              this.$store.state.AmountPayment = result.data.promptpay_confirm_result.amount
              this.$store.state.time = 0
              this.$store.state.PaymentType = 3
              clearInterval(this.$store.state.loopPP)
              // alert('ชำระ promptpay = ' + JSON.stringify(result))
            }
            if (result.data.status == 'completed' && (result.data.method == "pay9_debit" || result.data.method == "pay9_credit")) {
              console.log('completed = ', result)
              this.$store.state.AmountPayment = result.data.amount
              this.$store.state.memberProfile = result.data.member
              this.$store.state.time = 0
              this.$store.state.PaymentType = 4
              clearInterval(this.$store.state.loopPP)
              // alert('ชำระ promptpay = ' + JSON.stringify(result))
            }
          } else {
            this.$store.state.ppError = 1
            console.log('PPerror = ', result)
          }
          // else {
          //   console.log('error = ', result)
          //   clearInterval(this.$store.state.loopPP)
          //   swal
          //     .fire({
          //       title: 'ระบบมีปัญหากรุณาติดต่อเจ้าหน้าที่',
          //       text:  result.message,
          //       type: 'error',
          //       allowOutsideClick: false,
          //     })
          // }
        },
        error => {
          this.$store.state.ppError = 1
          console.log('PPerror = ', error)
          // alert(JSON.stringify(error))
        }
      )
    }
  },
  mounted() {
    // setTimeout(() => {
    // this.$store.state.PaymentType = 4
    // }, 10000)
    console.log('Promptpay ready!! ' + this.time)
    setTimeout(() => {
      this.genqrcode()
    }, 1000)
    // this.$store.state.PaymentType = 3
    // this.$store.state.AmountPayment = 1
  }
}



// WEBPACK FOOTER //
// ./src/js/type/promptpay.js